module.exports = __webpack_public_path__ + "static/media/Template_32.c8984a1e.png";